<template>
  <v-row class="align-stretch" justify="center" align-content="center">
    <v-col cols="12" sm="6" md="4" lg="4">
      <SingleValueChart
          :title="$t('components.ReviewsPercentages.TotalReviews')"
          :data="stats.total_reviews"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="4" lg="4">
      <SingleValueChart
          :title="$t('components.ReviewsPercentages.AverageRating')"
          :data="average_rating.toFixed(1) + '⭐'"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="4" lg="4">
      <SingleValueChart
          :title="$t('components.ReviewsPercentages.MostFrequentRating')"
          :data="`⭐⭐⭐⭐⭐`.slice(0, most_frequent_rating.rating)"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="6">
      <SingleValueChart
          :title="$t('components.ReviewsPercentages.TotalPositiveReviews')"
          :data="total_positive_reviews"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="6">
      <SingleValueChart
          :title="$t('components.ReviewsPercentages.TotalReviewsRepliedTo')"
          :data="stats.total_reviews_replied_to"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
  </v-row>
</template>

<script>
import SingleValueChart from '@/components/dashboard/charts/SingleValueChart';


export default {
  name: 'ReviewsPercentages',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    reviewsData: {
      type: Object,
      required: true
    },
    reportMode: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    stats: {
      total_reviews: 0,
      total_blocked_reviews: 0,
      total_reviews_replied_to: 0,
      total_qr_scans: 0,
    },
    most_frequent_rating: {
      rating: 0,
      count: 0
    },
    average_rating: 0,
    total_positive_reviews: 0
  }),
  methods: {
    updateStats(data) {
      if (data) {
        this.stats = data;
        this.computeFrequentRating()
        this.computeAverageRating();
        this.computePositiveReviews();
      }
    },
    computeFrequentRating() {
      if (this.reviewsData) {
        const ratings = this.reviewsData.review_statistics.by_rating;
        const max = Math.max(...Object.values(ratings));
        const ratingKey = Object.keys(ratings).find(key => ratings[key] === max);
        if (max > 0) {
          this.most_frequent_rating = {
            rating: ratingKey,
            count: max
          }
        }
      }
    },
    computeAverageRating() {
      if (this.reviewsData) {
        const ratings = this.reviewsData.review_statistics.by_rating;
        const total = Object.values(ratings).reduce((acc, val) => acc + val, 0);
        const sum = Object.keys(ratings).reduce((acc, key) => acc + key * ratings[key], 0);
        if (total > 0)
          this.average_rating = sum / total;
      }
    },
    computePositiveReviews() {
      if (this.reviewsData) {
        const ratings = this.reviewsData.review_statistics.by_rating;
        const positiveRatings = Object.keys(ratings).filter(key => key >= 4);
        this.total_positive_reviews = positiveRatings.reduce((acc, key) => acc + ratings[key], 0);
      }
    }
  },
  watch: {
    reviewsData(value) {
      this.updateStats(value);
    }
  },
  components: {SingleValueChart}
}
</script>